import React from "react"
import { Button } from "ksc-portal-common-components/shadcn"
import PropTypes from "prop-types"

import ErrorSVG from "./element"
import { ERROR_OBJECTS } from "./constants"

class ErrorPage extends React.Component {
  componentDidMount() {
    const { removeSidebar } = this.props
    removeSidebar()
  }

  render() {
    const {
      match: {
        params: { code },
      },
      onReset,
    } = this.props

    const error = ERROR_OBJECTS[code] || ERROR_OBJECTS["404"]
    return (
      <div className="p-12">
        <div className="h-[calc(100vh-160px)] bg-white flex flex-col items-center justify-center">
          {ErrorSVG({ error })}
          {onReset && (
            <Button
              variant="secondary"
              className="mt-4"
              onClick={onReset}
              data-testid="return-to-homepage"
            >
              Home Page
            </Button>
          )}
        </div>
      </div>
    )
  }
}

ErrorPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      code: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  removeSidebar: PropTypes.func.isRequired,
  onReset: PropTypes.func,
}

ErrorPage.defaultProps = {
  onReset: null,
}

export default ErrorPage
